import React, { useState, useEffect } from 'react';
import { ListboxCombobox } from "./AutoCompleteUtility";
import { USBIconChevronDown } from '@usb-shield/components-react/dist/cjs';
import "./AutoCompleteDropdown.css";

const AutoCompleteDropdown = ({listItems,onItemSelect,comboboxId,autocompleteInputId,listboxID,arrowId, label}) => {
    useEffect(() => {
        var Combobox = new ListboxCombobox(
            document.getElementById(comboboxId),
            document.getElementById(autocompleteInputId),
            document.getElementById(listboxID),
            searchItems,
            false,
            function () {
                // on show
                document.getElementById(arrowId)
                    .setAttribute('aria-label', `Hide ${label} options`);
            },
            function () {
                // on hide
                if(document.getElementById(arrowId)){
                    document.getElementById(arrowId)
                    .setAttribute('aria-label', `Show ${label} options`);
                }               
            },
            function(term) {
                let filtereOobj = listItems.filter(item => item.term == term)[0]
                onItemSelect(filtereOobj)
            },
            document.getElementById(arrowId)
        );

        
    }, [])
    const searchItems = (searchString) => {
        var results = [];
        for (var i = 0; i < listItems.length; i++) {
            var item = (listItems[i].term).toLowerCase();
            if (item.includes(searchString.toLowerCase())) {
                results.push(listItems[i].term);
            }
        }

        return results;
    }
    return (
        <div className="services">
            <div role="combobox"
                aria-expanded="false"
                aria-owns={listboxID}
                aria-haspopup={listboxID}
                id={comboboxId}
                className="combobox">
                <input type="text"
                    aria-autocomplete="both"
                    aria-controls={listboxID}
                    aria-labelledby="ex3-label"
                    id={autocompleteInputId}
                    placeholder={label} />
                <div className="combobox-dropdown"
                    id={arrowId}
                    tabIndex={-1}
                    role="button"
                    aria-label={`Show ${label} options`}>
                        <USBIconChevronDown title={' '}/>
                </div>
            </div>
            <ul aria-labelledby="ex3-label"
                role="listbox"
                id={listboxID}
                className="listbox hidden">
            </ul>
        </div>
    )
}
export default AutoCompleteDropdown;